import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { PATHS } from '../../../navigation/data';

export const CompaniesSettings = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const goToCompanies = useCallback(() => {
    navigate(PATHS.COMPANIES);
  }, [navigate]);

  return (
    <div
      className="info-card flex-center-center-column-nowrap hoverable settings-card-dimensions"
      onClick={goToCompanies}>
      <div className="boldText7 margin-b-24">{t('SETTINGS.COMPANIES_TITLE')}</div>
      <div className="normalText4 text-center">{t('SETTINGS.COMPANIES_DESCRIPTION')}</div>
    </div>
  );
};
